import React from 'react';
import { ScrollElement } from '@prisjakt/ui-scroll';

import * as S from './styles';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  closeMenu: () => void;
  showSidebar?: boolean;
};

const Menu = ({ children, style, closeMenu, showSidebar }: Props) => {
  return (
    <S.OutsideClickTracker
      active
      onClickOutside={closeMenu}
      onEscapeKey={closeMenu}
      sidebar={showSidebar}
    >
      <S.MobileMenu
        sidebar={Boolean(showSidebar)}
        style={style}
        data-test="MobileMenu"
      >
        <ScrollElement name="Mobile Menu">{children}</ScrollElement>
      </S.MobileMenu>
    </S.OutsideClickTracker>
  );
};

export default Menu;
